import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"

import ArticlePage from "./abstract-article"
import { store } from "../articleTypes"

const StoresPage = ({ data, ...props }) => {
  return (
    <ArticlePage
      {...props}
      article={data.store}
      articleType={store}
      articleTypeTag="store"
      articleTypePath="/stores"
    />
  )
}
StoresPage.propTypes = {
  data: PropTypes.any,
}

export const query = graphql`
  query($slug: String!) {
    store: markdownRemark(
      fields: { contentKind: { eq: "store" }, slug: { eq: $slug } }
    ) {
      ...TinaRemark
      ...ArticlePageFragment
    }
  }
`

export default StoresPage
